/**
 * Gate that delays syncUserClaims in the onAuthStateChanged listener
 * until the user profile has been created during signup/SSO flows.
 *
 * For login and page-refresh flows, no gate is set, so the listener
 * proceeds immediately.
 */

let resolve: (() => void) | null = null;
let reject: ((err: unknown) => void) | null = null;
let gate: Promise<void> | null = null;

export function openProfileGate() {
  gate = new Promise<void>((res, rej) => {
    resolve = res;
    reject = rej;
  });
}

export function closeProfileGate() {
  resolve?.();
  resolve = null;
  reject = null;
  gate = null;
}

export function rejectProfileGate(err: unknown) {
  reject?.(err);
  resolve = null;
  reject = null;
  gate = null;
}

export function getProfileGate() {
  return gate;
}
